<template>
    <div>
        <h3>{{ language }}</h3>
        <p v-html="translation" v-if="translation" class="translation-container"></p>
        <p v-else><i style="color: grey">{{ $t('views.translationsView.noTranslationAvailable') }}</i></p>
        <v-divider class="pb-3"></v-divider>
    </div>
</template>

<script>
export default {
    name: "TranslationEntry",
    props: {
        language: {
            type: String,
            required: true,
            default: ""
        },
        translation: {
            type: String,
            required: true,
            default: ""
        }
    }

}
</script>

<style>
.translation-container p {
    margin-bottom: 0;
}
</style>